class OptionSetConfigError extends Error {
    /**
     * @param {string} message
     * @param {OptionSet} optionSet
     * @param {AbstractItem} [triggeredByItem] Used in the error message to indicate an example item
     *                                         that will trigger this option set.
     */
    constructor(message, optionSet, triggeredByItem) {
        super(message);
        this.optionSet = optionSet;
        this.triggeredByItem = triggeredByItem;
    }
}

module.exports = OptionSetConfigError;
